<div class="row mt-4 p-4">
  <div class="col-12">
    <div class="text-center">
      <h1 class="text-primary custom-tile-header">{{ 'onboarding.title' | translate }}</h1>
      <p>{{ 'onboarding.subtitle' | translate }}</p>
    </div>
    <div class="row justify-content-evenly text-center">
      <ng-container *ngFor="let step of steps">
        <div class="col-3 step-div" [ngClass]="step.complete ? 'border-soft-success' : ''">
          <h4 class="mt-2">
            <i *ngIf="step.complete" class="fas fa-check-circle text-success"></i> {{ 'onboarding.step_label' | translate }} {{ step.id }}
          </h4>
          <hr />
          <h4>{{ step.labelKey | translate }}</h4>
          <img src="{{ step.image }}" alt="{{ step.labelKey | translate }}" class="img-fluid mb-2 thumbnail" />
          <div class="d-flex flex-column" style="min-height: 200px;">
            <p><b>{{ 'onboarding.why_we_need_it' | translate }}</b> {{ step.descriptionKey | translate }}</p>
            <button class="btn text-white w-100 mt-auto" [ngClass]="step.complete ? 'btn-success' : 'btn-primary'"
              (click)="openModal(step.id)" [disabled]="step.complete && step.id !== OnboardingSteps.WebsiteAccess">
              <i [ngClass]="step.complete ? 'fas fa-check-circle' : step.icon"></i>
              {{ step.complete ? ('onboarding.completed' | translate) : (step.callToActionKey | translate) }}
            </button>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
